<template>
  <div class="login col-xl-4 mx-auto" @keyup.enter="login">
    <h3 class="mb-4">Login to your account</h3>
    <b-alert show variant="danger" v-if="error" class="text-left">
      <p class="mb-0">Invalid username or password.</p>
    </b-alert>
    <b-form-group label="Email" :state="IsFieldValid($v.email)" :invalid-feedback="RequiredMessage('Email', $v.email)">
      <b-form-input v-model="$v.email.$model" :state="IsFieldValid($v.email)" />
    </b-form-group>
    <b-form-group label="Password" :state="IsFieldValid($v.password)" :invalid-feedback="RequiredMessage('Password', $v.password)">
      <b-form-input v-model="$v.password.$model" :state="IsFieldValid($v.password)" type="password" />
    </b-form-group>
    <b-button @click="login" variant="success" :disabled="isLoading">
      <span v-if="!isLoading">Login</span>
      <span v-else><b-spinner small></b-spinner> Please Wait...</span>
    </b-button>
    <div class="extras mt-2">
      <span class="account-item text-right">
        <router-link :to="{ name: 'account/register'}" class="account-link">Create an account</router-link>
      </span>
      <span class="text-center center-pipe">|</span>
      <span class="account-item text-left">
        <router-link :to="{ name: 'account/forgot'}" class="account-link">Forgot your password?</router-link>
      </span>
    </div>
  </div>
</template>

<script>
import UserService from '../services/UserService.js'
import { required, email } from 'vuelidate/lib/validators'


export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      error: false,
      isLoading: false
    }
  },
  validations() {
    return {
      email: { required, email },
      password: { required }
    }
  },
  methods: {
    login() {
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.isLoading = true
      UserService.login(this.email, this.password).then(res => {
        this.$store.dispatch('user/setUserData', res.data).then(() => {
          this.$router.push({
            name: 'home'
          })
        })
      }).catch(() => {
        this.error = true
        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped>
.extras .account-item {
  display: inline-block;
  width: 48%;
}

.center-pipe {
  width: 4%;
  margin-left: 6px;
  margin-right: 6px;
}
</style>